import './MarkupLayer.css'

const svgProps = {
  viewBox: '0 0 24 24',
  fill: 'none',
  stroke: 'currentColor',
  strokeWidth: 2,
  strokeLinecap: 'round',
  strokeLinejoin: 'round',
}

const ICONS = {
  select: (
    <svg {...svgProps}>
      <path d="M4 3l7 17 2.5-6.5L20 11z" />
    </svg>
  ),
  highlight: (
    <svg {...svgProps}>
      <path d="M4 20h16" />
      <path d="M6 16l8-8 4 4-8 8H6z" />
    </svg>
  ),
  textbox: (
    <svg {...svgProps}>
      <rect x="4" y="6" width="16" height="12" rx="1" />
      <path d="M8 10h8M8 14h5" />
    </svg>
  ),
  line: (
    <svg {...svgProps}>
      <line x1="5" y1="19" x2="19" y2="5" />
    </svg>
  ),
  arrow: (
    <svg {...svgProps}>
      <line x1="5" y1="19" x2="17" y2="7" />
      <polyline points="11 7 17 7 17 13" />
    </svg>
  ),
  ink: (
    <svg {...svgProps}>
      <path d="M4 16c2-6 4 2 7-2s3-8 9-6" />
    </svg>
  ),
  rect: (
    <svg {...svgProps}>
      <rect x="5" y="6" width="14" height="12" rx="1" />
    </svg>
  ),
  ellipse: (
    <svg {...svgProps}>
      <ellipse cx="12" cy="12" rx="8" ry="5.5" />
    </svg>
  ),
}

const TOOLS = [
  { id: 'select', title: 'Select' },
  { id: 'highlight', title: 'Highlight' },
  { id: 'textbox', title: 'Text box' },
  { id: 'line', title: 'Line' },
  { id: 'arrow', title: 'Arrow' },
  { id: 'ink', title: 'Pen' },
  { id: 'rect', title: 'Rectangle' },
  { id: 'ellipse', title: 'Ellipse' },
]

export function MarkupToolbar({ tool, onTool, color, onColor, canDelete, onDelete, disabled }) {
  return (
    <div className="markup-toolbar">
      {TOOLS.map((t) => (
        <button
          key={t.id}
          type="button"
          className={'markup-tool' + (tool === t.id ? ' is-active' : '')}
          onClick={() => onTool(t.id)}
          disabled={disabled}
          title={t.title}
          aria-label={t.title}
          aria-pressed={tool === t.id}
        >
          {ICONS[t.id]}
        </button>
      ))}
      <label className="markup-color" title="Color">
        <input
          type="color"
          value={color}
          onChange={(e) => onColor(e.target.value)}
          disabled={disabled}
          aria-label="Markup color"
        />
      </label>
      <button
        type="button"
        className="markup-tool"
        onClick={onDelete}
        disabled={disabled || !canDelete}
        title="Delete markup"
        aria-label="Delete markup"
      >
        <svg {...svgProps}>
          <polyline points="3 6 5 6 21 6" />
          <path d="M19 6l-1 14H6L5 6" />
          <path d="M10 11v6M14 11v6" />
          <path d="M9 6V4h6v2" />
        </svg>
      </button>
    </div>
  )
}
